import { generateClient } from 'aws-amplify/data';

let client;
const cache = new Map();
function getClient() { return client || (client = generateClient({ authMode: 'userPool' })); }
function confirmed(result) {
  if (result.errors?.length) throw new Error(result.errors.map(e => e.message).join('; '));
  if (!result.data) throw new Error('The competition service returned no data');
  let state = result.data;
  // AWSJSON is serialized on the GraphQL wire. Older Lambda versions also
  // stringify their result, so accept both during deployment and refreshes.
  for (let depth = 0; depth < 3 && typeof state === 'string'; depth++) state = JSON.parse(state);
  if (!state || typeof state !== 'object' || !Array.isArray(state.teams) || !Array.isArray(state.scores)) {
    throw new Error('The event service returned incomplete data. Please retry.');
  }
  return state;
}
async function request(query, variables, field) {
  try {
    const result = await getClient().graphql({ query, variables });
    return confirmed({ ...result, data: result.data?.[field] });
  } catch (err) {
    // Amplify may reject with a GraphQL result object rather than an Error.
    const message = err?.errors?.map(e => e.message).filter(Boolean).join('; ') || err?.message;
    throw new Error(message || 'Could not load shared event data. Please retry.');
  }
}
function remember(masterEventId, state) {
  cache.set(masterEventId, { ...cache.get(masterEventId), ...state });
  return state;
}
export const competitionService = {
  peek(masterEventId) { return cache.get(masterEventId) || { teams: [], scores: [] }; },
  async load(masterEventId, activityId) {
    const state = await request(`query CompetitionState($masterEventId: ID!, $activityId: ID) {
      competitionState(masterEventId: $masterEventId, activityId: $activityId)
    }`, { masterEventId, activityId: activityId || null }, 'competitionState');
    return remember(masterEventId, state);
  },
  async command(masterEventId, activityId, action, payload = {}) {
    const state = await request(`mutation CompetitionCommand($masterEventId: ID!, $activityId: ID, $action: String!, $payload: AWSJSON) {
      competitionCommand(masterEventId: $masterEventId, activityId: $activityId, action: $action, payload: $payload)
    }`, { masterEventId, activityId: activityId || null, action, payload: JSON.stringify(payload) }, 'competitionCommand');
    return remember(masterEventId, state);
  },
};
